// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-data-view[data-v-43d749e8]{padding:.3125rem;line-height:1.5625rem;font-size:1rem}", ""]);
// Exports
module.exports = exports;
